import { getPrevalentSeasonDescription, SeasonDescription } from '../seasons/seasons';

export class Term {
  public id: string;
  public instanceId: string;

  public startDate: Date;
  public endDate: Date;

  public startDateString: string;
  public endDateString: string;

  public isOSU: boolean;
  public countryCode: string;
  public seasonDescription: SeasonDescription;
  public locale: string;
  public constructor(data: Partial<Record<Exclude<keyof Term, 'id'>, any>>, locale: string) {
    Object.assign(this, data);

    if (this.startDate > this.endDate) {
      let tempDate = this.startDate;
      this.startDate = this.endDate;
      this.endDate = tempDate;
    }

    // TODO: Refactor this when working on DVT-2483, reuse SupportedLanguages and SupportedLanguageLocales.
    // Use en-GB as a default culture
    // Use date format dd Month yyyy
    this.locale =
      !locale || locale.toLowerCase() === 'en' ? 'en-GB' : locale === 'zh' ? 'zh-CN' : 'default';

    this.startDateString = this.startDate.toLocaleDateString(this.locale, { dateStyle: `long` });
    this.endDateString = this.endDate.toLocaleDateString(this.locale, { dateStyle: `long` });

    this.id = `term-${this.startDate.getTime()}-${this.endDate.getTime()}`; // this id is also used to sort and dedupe items

    this.seasonDescription = getPrevalentSeasonDescription(
      this.startDate,
      this.endDate,
      this.isOSU,
    );
  }
}
